<template>
  <a-config-provider :locale="locale">
    <div class="center-div">
      <div class="header" :class="{ medata1: $route.name === 'medata' }">
        <div class="image1-box">
          <img :src="require(options.language === 'zh' ? '@/assets/image/u0.jpg' : '@/assets/image/u1.jpg')" class="image1" alt="..."/>
          <a-space class="language-control">
            <span class="language-btn" :class="{ active: options.language === 'zh' }" @click="change('zh')">中文</span>
            <span class="language-btn" :class="{ active: options.language === 'ru' }" @click="change('ru')">Pусский</span>
          </a-space>
          <div class="introduce1-box">
            <div class="introduce1-content" :title="introduce">
              {{ introduce }}
            </div>
          </div>
        </div>
      </div>
      <router-view class="content"></router-view>
      <div class="footer m-s-title">
        <div class="footer-text">
          {{ '致谢' | label }}
        </div>
        <div class="footer-text">
          {{ '中心' | label }}
        </div>
        <div class="footer-text">
          {{ '中心2' | label }}
        </div>
        <div class="footer-text">
          {{ '联系邮箱' | label }}
        </div>
      </div>
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import {options} from "@/commom/initial";
import {api} from "@/api";

export default {
  name: 'App',
  data() {
    return {
      locale: zh_CN,
      options,
      introduce: ''
    }
  },
  mounted() {
    this.fetchIntroduce();
  },
  methods: {
    fetchIntroduce() {
      api.selectIntroduce().then(res => {
        this.introduce = res.data.content || "";
      })
    },
    change(key) {
      window.localStorage.setItem('_language', key || 'zh');
      this.$router.go(0);
    }
  }
}
</script>

<style scoped>
.header {
  height: 365px;
  overflow: hidden;
}

.medata1 {
  height: 95px;
}

.image1-box {
  position: relative;
}

.image1 {
  width: 100%;
  height: auto;
}

.language-control {
  position: absolute;
  top: 50px;
  right: 58px;
}

.language-btn {
  color: white;
  font-weight: bold;
  cursor: pointer;
  padding: 3px 2px;
}

.language-btn.active {
  border-bottom: 2px solid #00ffff;
}

.introduce1-box {
  position: absolute;
  top: 96px;
  left: 50px;
  right: 50px;
  color: white;
}

.introduce1-content {
  padding-top: 10px;
  text-indent: 38px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
}

.content {
  border: 1px solid black;
}

.footer{
  background-color: #0D2760;
  color: white;
  padding: 20px;
}

.footer a {
  color: hsla(0,0%,100%,.9);
  text-decoration: none;
}

.footer-text {
  color: white;
  font-weight: bold;
  text-align: center;
}
</style>
